import { all, call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { fetchCarrierOptionsApi, fetchStoneOptionsApi, fetchWarehouseLocationsApi, fetchWarehouseOptionsApi } from './meta.api';
import {
  fetchOptionsFailure,
  fetchOptionsRequest,
  fetchOptionsSuccess,
  fetchWarehouseLocationsFailure,
  fetchWarehouseLocationsRequest,
  fetchWarehouseLocationsSuccess,
} from './meta.slice';

import { ShipmentLocation } from '@stone/interfaces';
import { handleSagaError } from '@stone/sagaHelpers';

function* fetchOptionsSaga(_action: PayloadAction<any | undefined>): Generator<any, void, any> {
  try {
    const [options, warehouses, carriers] = yield all([call(fetchStoneOptionsApi), call(fetchWarehouseOptionsApi), call(fetchCarrierOptionsApi)]);
    yield put(fetchOptionsSuccess({ options, warehouses, carriers }));
  } catch (error: any) {
    yield handleSagaError(error, fetchOptionsFailure, 'Failed to load options');
  }
}

function* fetchWarehouseLocationsSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const response: ShipmentLocation[] = yield call(fetchWarehouseLocationsApi, action.payload);
    yield put(fetchWarehouseLocationsSuccess(response));
  } catch (error: any) {
    yield handleSagaError(error, fetchWarehouseLocationsFailure, 'Failed to fetch warehouse locations');
  }
}

export default function* metaSaga() {
  yield takeLatest(fetchOptionsRequest.type, fetchOptionsSaga);
  yield takeLatest(fetchWarehouseLocationsRequest.type, fetchWarehouseLocationsSaga);
}
